import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
var ErrorLog = /*#__PURE__*/function (_VuexModule) {
  function ErrorLog() {
    var _this;
    _classCallCheck(this, ErrorLog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ErrorLog, [].concat(args));
    _defineProperty(_this, "logs", []);
    return _this;
  }
  _inherits(ErrorLog, _VuexModule);
  return _createClass(ErrorLog, [{
    key: "ADD_ERROR_LOG",
    value: function ADD_ERROR_LOG(log) {
      this.logs.push(log);
    }
  }, {
    key: "CLEAR_ERROR_LOG",
    value: function CLEAR_ERROR_LOG() {
      this.logs.splice(0);
    }
  }, {
    key: "AddErrorLog",
    value: function AddErrorLog(log) {
      this.ADD_ERROR_LOG(log);
    }
  }, {
    key: "ClearErrorLog",
    value: function ClearErrorLog() {
      this.CLEAR_ERROR_LOG();
    }
  }]);
}(VuexModule);
__decorate([Mutation], ErrorLog.prototype, "ADD_ERROR_LOG", null);
__decorate([Mutation], ErrorLog.prototype, "CLEAR_ERROR_LOG", null);
__decorate([Action], ErrorLog.prototype, "AddErrorLog", null);
__decorate([Action], ErrorLog.prototype, "ClearErrorLog", null);
ErrorLog = __decorate([Module({
  dynamic: true,
  store: store,
  name: 'errorLog'
})], ErrorLog);
export var ErrorLogModule = getModule(ErrorLog);